export enum LoadingInterfaceTypesEnum {
  LOADING_START = 'LOADING_START',
  LOADING_FINISHED = 'LOADING_FINISHED',
}
